import { defineStore } from 'pinia'
import { ref, watch } from 'vue'
import useValidate from '@/shared/lib/validate'
import { cloneDeep } from 'lodash'
import type { ReportSubscriptionType } from './types'

export const useReportSubscriptionModel = defineStore('report_subscription_subscription', () => {
  const { email } = useValidate()
  const openForm = ref(false)

  /* Поля формы */
  const fields: ReportSubscriptionType = {
    object_list_id: 0,
    receivers: [],
    type: 1,
    report_type: '',
    params: {
      period: 1,
      time: '00:00',
    },
    filters: {},
  }

  /* Данные формы */
  const data = ref<ReportSubscriptionType>(cloneDeep(fields))

  /* Правила валидации */
  const rules = {
    recipients: [(value: string) => email(value)],
  }

  /* Очищаем данные при закрытии окна */
  watch(openForm, () => {
    if (openForm.value === false) {
      data.value = cloneDeep(fields)
    }
  })

  /* Обновляем данные при смене типа */
  watch(
    () => data.value.type,
    () => (data.value.params.period = 1),
  )

  return {
    openForm,
    data,
    rules,
  }
})
